import RichTextCopy from '@/components/shared/RichTextCopy/RichTextCopy';
import { cn } from '@/utils/styles';
import Link from 'components/shared/Link/Link';
import Media from 'components/shared/Media/Media';
import { AuthorProps } from '../types';
import { liveUpdateAttrs } from 'libs/contentful/utils';

export type BlogAuthorProps = AuthorProps & {
  byLinePrefix?: string;
  className?: string;
};

const BlogAuthor = ({ name, title, image, bio, url, internalPage, sys, byLinePrefix, className }: BlogAuthorProps) => {
  const hasLink = url || internalPage;

  return (
    <div className={cn({ 'grid grid-cols-[auto_1fr] gap-4 items-start': image }, className)}>
      {image && (
        <div className="h-12 w-12 rounded-full">
          <Media media={image} className="object-cover rounded-full h-full" />
        </div>
      )}

      <div className="font-sans items-center">
        <p className="text-label-saans font-[670]" {...liveUpdateAttrs(sys?.id, 'name')}>
          {byLinePrefix && <span className="text-content-secondary">{byLinePrefix} </span>}
          {hasLink ? (
            <Link href={url} internalPage={internalPage}>
              {name}
            </Link>
          ) : (
            name
          )}
        </p>
        {title && (
          <p className="pt-1 text-content-secondary font-[570] leading-[1.2]" {...liveUpdateAttrs(sys?.id, 'title')}>
            {title}
          </p>
        )}
        {bio && (
          <div className="py-2 text-content-primary leading-[1.4]">
            <RichTextCopy copy={bio} />
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogAuthor;
